import { FormatPhone, TextInput } from '@core/components/Inputs';
import { Grid, IconButton, InputAdornment, Tooltip } from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { FieldArray } from 'formik';
import React from 'react';
import { BotaoContato } from './BotaoContato';

const Telefone = ({
  arrayHelpers,
  index,
  isEstrangeira,
  inputSize,
  telefone,
  contatoIndex,
  handleChange,
  handleBlur,
  readOnly,
}) => {
  return (
    <Grid container spacing={3} key={index} className="mt-10">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container spacing={2}>
          {isEstrangeira && (
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <TextInput
                readOnly={readOnly}
                id={`pessoa.contatos[${contatoIndex}].telefonesAdicionais[${index}].codigoPais`}
                fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                value={telefone.codigoPais}
                label="Código"
                maxLength={3}
              />
            </Grid>
          )}
          <Grid item xs={inputSize} sm={inputSize} md={inputSize} lg={inputSize} xl={inputSize}>
            <TextInput
              readOnly={readOnly}
              InputProps={{
                inputComponent: FormatPhone,
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Excluir registro" placement="bottom">
                      <IconButton onClick={() => arrayHelpers.remove(index)}>
                        <RemoveCircleIcon />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              id={`pessoa.contatos[${contatoIndex}].telefonesAdicionais[${index}].numero`}
              fullWidth
              value={telefone.numero}
              onChange={handleChange}
              onBlur={handleBlur}
              label="Telefone adicional"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const TelefoneAdicional = ({
  contatoIndex,
  isEstrangeira,
  inputSize,
  telefonesAdicionais = [],
  handleChange,
  handleBlur,
  readOnly,
}) => {
  const exibirAdicionar = telefonesAdicionais.length < 2;

  return (
    <FieldArray name={`pessoa.contatos[${contatoIndex}].telefonesAdicionais`}>
      {(arrayHelpers) => {
        const telefones = telefonesAdicionais.map((item, index) => {
          return (
            <Telefone
              key={index}
              readOnly={readOnly}
              isEstrangeira={isEstrangeira}
              inputSize={inputSize}
              contatoIndex={contatoIndex}
              telefone={item}
              index={index}
              arrayHelpers={arrayHelpers}
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
          );
        });
        return (
          <>
            {telefones}
            {!readOnly && exibirAdicionar && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <BotaoContato onClick={() => arrayHelpers.push({})}>Adicionar telefone</BotaoContato>
              </Grid>
            )}
          </>
        );
      }}
    </FieldArray>
  );
};

export default TelefoneAdicional;
